// extracted by mini-css-extract-plugin
module.exports = {"root":"app-header-module_root_3afMB","headerContent":"app-header-module_headerContent_2q1TG"};